import permissions from 'api/Apollo/permissions';
import { METHOD, PATH } from 'api/control/control-api';
import { normalizeResponse, useControlProxy } from 'api/control/useControlProxy';
import { isNil } from 'lodash';

export default function useDeliverEvent(options = {}) {
  const [call, response] = useControlProxy({
    permission: permissions.deliverEvents,
    ...options,
  });

  const executeDeliverEvents = ({ clusterId, integration, inputEvent, originalEvent }) => {
    return call({
      path: PATH.DeliverEvent,
      method: METHOD.POST,
      body: { integration, inputEvent, originalEvent },
      clusterId,
    });
  };

  return [executeDeliverEvents, normalizeResponse(response, transformDeliverEventResponse)];
}

function transformDeliverEventResponse(response) {
  if (!response) {
    return response;
  }

  const { integrationResponse, error } = response;

  if (!isNil(error)) {
    return { error };
  }

  return { integrationResponse };
}
